'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.tutorial.edit', [])
  .controller('TutorialEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tutorial/edit/index.js